import base from '@/http/url_base';

export default {
  GET_BUDGET_ARTICLES: base.API_ACHAT + '/budget-articles',
  GET_PRIX_ARTICLES: base.API_ACHAT + '/prix-articles',
};
